import { createContext, useContext, useEffect, useState } from "react";
import {
  MARKET_STORAGE_KEY,
  DEFAULT_MARKET,
  marketFromUrl,
  marketFromStorage,
  countryToMarket,
  marketToLink,
} from "@/lib/market";

const MarketContext = createContext(null);

function resolveInitialMarket() {
  const fromUrl = marketFromUrl();
  if (fromUrl) {
    try {
      localStorage.setItem(MARKET_STORAGE_KEY, fromUrl);
    } catch (e) {}
    return { market: fromUrl, needsGeo: false };
  }
  const stored = marketFromStorage();
  if (stored) return { market: stored, needsGeo: false };
  return { market: DEFAULT_MARKET, needsGeo: true };
}

export function MarketProvider({ children }) {
  const [init] = useState(resolveInitialMarket);
  const [market, setMarket] = useState(init.market);

  useEffect(() => {
    if (!init.needsGeo) return;
    let cancelled = false;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/geo`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (cancelled) return;
        const m = countryToMarket(d && d.country);
        if (m) setMarket(m);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [init.needsGeo]);

  return (
    <MarketContext.Provider value={{ market, ctaUrl: marketToLink(market) }}>
      {children}
    </MarketContext.Provider>
  );
}

export function useMarket() {
  return useContext(MarketContext);
}
